export default "__VITE_ASSET__B25FGXwD__"